import React from 'react';
import { Link } from 'react-router-dom';
import { useGetTerms } from '../../services/queries';
import styles from './Terms.module.css';
import { useTranslation } from 'react-i18next';

const Terms = () => {
    const { i18n, t } = useTranslation();
    const storedLang = i18n.language;
    const {data:terms} = useGetTerms(storedLang);
    
    const parseMarkdown = (text) => {
      if (!text) return '';
      
      // Replace markdown syntax with HTML
      return text
        // Bold
        .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
        // Italic
        .replace(/\*(.*?)\*/g, '<em>$1</em>')
        // Underline
        .replace(/_(.*?)_/g, '<u>$1</u>')
        // Line breaks
        .replace(/\n/g, '<br />');
    };
    
    return (
      <div className="container py-5">
        <div className="row justify-content-center mt-5">
          <div className="col-lg-10">
            <div className="card shadow-sm">
              <div className="card-body p-4">
                <h1 className="text-center mb-4">{t('terms.title')}</h1>
                
                {terms ? (
                  <div 
                    className={styles['terms-content']}
                    dangerouslySetInnerHTML={{ __html: parseMarkdown(terms.term) }}
                  />
                ) : (
                  <div className="text-center">
                    <p>{t('terms.loading')}</p>
                  </div>
                )}

                {/* <div className="text-center mt-4">
                  <Link to="/" className="btn btn-primary">
                    {t('terms.back_to_home')}
                  </Link>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
};

export default Terms;
